var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.24409 17C2.59065 17 2.87501 16.8758 3.10606 16.645L9.92181 9.99834C10.2239 9.69662 10.375 9.38602 10.375 9.00444C10.375 8.62285 10.2328 8.30338 9.92181 8.01054L3.10606 1.35496C2.86613 1.12424 2.58177 1 2.24409 1C1.55985 1 1.00001 1.55019 1.00001 2.2335C1.00001 2.57072 0.999961 2.2335 1.00007 3L1 9L1.00002 15C1.00002 15 1.00001 15.4293 1.00001 15.7665C1.00001 16.4498 1.55985 17 2.24409 17Z",
    fill: "#329DFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluearrow);
export default __webpack_public_path__ + "static/media/bluearrow.c4261b361e575c7193bc2410612b5a5e.svg";
export { ForwardRef as ReactComponent };